var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service-tile",class:{'service-tile_disabled': !!_vm.disabled},on:{"click":_vm.onClick}},[_c('img',{attrs:{"src":_vm.service.imgSrc}}),_c('h5',{staticClass:"title"},[_vm._v(_vm._s(_vm.service.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }